import { Group, Skeleton, Stack } from '@mantine/core';

interface IChatConversationTileSkeletonProps {
  size?: 'sm' | 'md';
  showLastMessage?: boolean;
}

export function ChatConversationTileSkeleton({
  size = 'md',
  showLastMessage = true,
}: IChatConversationTileSkeletonProps) {
  const isNormalSize = size === 'md';
  const avatarSize = isNormalSize ? '2.7rem' : '2.1rem';

  return (
    <Group px={isNormalSize ? '0.75rem' : 'xs'} py={isNormalSize ? 'sm' : 0}>
      <Skeleton bdrs="999px" h={avatarSize} w={avatarSize} />

      <Stack gap={isNormalSize ? '0.5rem' : '0.3rem'} flex={1}>
        <Group justify="space-between">
          <Skeleton
            h={isNormalSize ? '1rem' : '0.6rem'}
            w={isNormalSize ? '8rem' : '6rem'}
          />
          {showLastMessage && <Skeleton h="0.6rem" w="2rem" />}
        </Group>
        {showLastMessage && <Skeleton h="0.6rem" w="12rem" />}
      </Stack>
    </Group>
  );
}
